<template>
  <article>
    <div v-if="entradaIsEmpty">
      <i class="fa  fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
    </div>
    <span v-else>{{ time.entrada }}</span>

    <span>-</span>

    <div v-if="saidaIsEmpty">
      <i class="fa  fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
    </div>
    <span v-else>{{ time.saida }}</span>

    <button @click="click">
      ×
    </button>
  </article>
</template>

<script>
export default {
  props: {
    time: {
      type: Object
    },
    click: {
      type: Function,
      required: true
    }
  },
  computed: {
    entradaIsEmpty() {
      return this.time.entrada === ''
    },
    saidaIsEmpty() {
      return this.time.saida === ''
    }
  }
}
</script>

<style scoped>
article {
  margin: 0px 10px 10px 0px;
  padding: 15px 10px;
  width: 130px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
  border-radius: 4px;
  border: 1px solid transparent;
}

div {
  width: 35px;
  text-align: center;
}

button {
  padding: 0;
  cursor: pointer;
  background: 0 0;
  border: 0;
  -webkit-appearance: none;
  float: right;
  font-size: 21px;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TimeSpan.vue